import { styled, css, keyframes } from "@mui/system";

const moveSentence = keyframes`
  0% {
    transform: translateY(0px);
    opacity: 1;
  }
  50% {
    transform: translateY(20px);
    opacity: 0;
  }
  100% {
    transform: translateY(-20px);
    opacity: 0;
  }
`;

const moveSentenceMobile = keyframes`
  0% {
    transform: translate(-50%, 0px);
    opacity: 1;
  }
  50% {
    transform: translate(-50%, 20px);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -20px);
    opacity: 0;
  }
`;

export const Styles = styled("div")(
  ({ theme }) => css`
    .description {
      font-family: "Instrument_Sans";
      font-weight: 500;
      font-size: 26px;
      overflow: hidden;

      .main-description {
        font-family: "Instrument_Sans";
        font-weight: 500;
        font-size: 26px;
      }

      /* Desktop dynamic container */
      .dynamic-container-visit {
        position: relative;
        display: inline-block;
        width : 600px;
        text-align: center;
        height: 32px; /* Should match line height */
        overflow: hidden;
        vertical-align: bottom;
      }

      .visit {
        position: absolute;
        left: 0;
        top: 0;
        color: #979797;
        font-weight: 600;
        font-size: 26px;
        line-height: 32px;
        right: 0;
        width: auto;
        opacity: 0;
        transform: translateY(-20px);
        transition: all 1s ease-in-out;

        @media (max-width: 992px) {
          font-size: 20px;
          width: auto;
        }

        /* Original mobile style */
        @media (max-width: 768px) {
          font-size: 16px;
          width: 100%;
          right: auto;
          left: 50%;
          bottom: 0px;
          transform: translate(-50%, -20px);
        }
      }

      .visit.visible {
        opacity: 1;
        transform: translateY(0px);
        animation: 100s ${moveSentence} 1s forwards ease-in-out;

        @media (max-width: 768px) {
          opacity: 1;
          transform: translate(-50%, 0px);
          animation: 100s ${moveSentenceMobile} 1s forwards ease-in-out;
        }
      }
    }
  `
);
